export enum InvoicesTableAccessor {
  ContactName = 'contactName',
  Description = 'description',
  DueDate = 'dueDate',
  EInvoiceStatus = 'eInvoiceStatus',
  InclVat = 'inclVat',
  IntegrationStatus = 'integrationStatus',
  InvoiceNumber = 'invoiceNo',
  IssueDate = 'issueDate',
  NetTotal = 'netTotal',
  PaidDate = 'paidDate',
  Status = 'status',
  Type = 'type',
}
